module.exports = __webpack_public_path__ + "img/mines2.bb9684c5.png";